export const SSL_TLS_BASE = "/v2/ssl-tls";
export const SSL_TLS_OVERVIEW = `${SSL_TLS_BASE}/overview`;
export const SSL_TLS_CONFIGURATION = `${SSL_TLS_BASE}/configuration`;

export function isSslTlsRoute(pathname) {
  if (!pathname) return false;
  return pathname.startsWith(SSL_TLS_BASE) || pathname.startsWith("/v2/certs");
}

export function isSslTlsOverviewRoute(pathname) {
  if (!pathname) return false;
  return pathname === SSL_TLS_OVERVIEW || pathname.startsWith(`${SSL_TLS_OVERVIEW}/`);
}
